import { MaskedLines, Reveal } from "@/components/aklive/motion";

const STAGES = ["Understand", "Define", "Build", "Refine"];

export const WhyAklive = () => (
  <section className="py-24 md:py-40" data-testid="why-aklive-section">
    <div className="container-ak">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-8">
        <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:col-span-6 lg:text-6xl">
          <MaskedLines
            lines={[
              "Business first.",
              <span key="l2" className="text-ember">
                Design second.
              </span>,
            ]}
          />
        </h2>
        <Reveal delay={0.2} className="lg:col-span-5 lg:col-start-8 lg:self-end">
          <p className="max-w-[520px] text-base leading-relaxed text-ink2 md:text-lg">
            We understand what the business needs to achieve before deciding what needs to be designed.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-16 md:mt-24">
        <ol className="grid grid-cols-2 border-y border-line md:grid-cols-4 md:divide-x md:divide-line">
          {STAGES.map((s, i) => (
            <li key={s} className="flex items-baseline gap-4 px-2 py-7 md:px-8 md:py-9" data-testid={`why-stage-${i}`}>
              <span className="font-mono text-[10px] tracking-[0.2em] text-ember md:text-xs">0{i + 1}</span>
              <span className="font-display text-xl font-bold tracking-tight text-ink md:text-2xl">{s}</span>
              {i < STAGES.length - 1 && (
                <span aria-hidden="true" className="ml-auto hidden text-ink2 md:inline">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>
      </Reveal>
    </div>
  </section>
);
